module.exports = __webpack_public_path__ + "components/easter-infographic/static/background-267545224068b163211a62ddd3c8acec.jpg";